import { useComputed } from '@preact/signals'
import type { ViewState } from '#contract'
import { useClientBridge } from './client-context.ts'

/**
 * Reads a slice of the view. The component re-renders only when the slice changes
 * (`Object.is`), so select primitives or objects the engine keeps stable, never build
 * a new object in `select`.
 */
export function useView<T>(select: (view: ViewState) => T): T {
  const { view } = useClientBridge()
  return useComputed(() => select(view.value)).value
}
